import * as React from "react";
import isString from "lodash/isString";
import trim from "lodash/trim";
import trunc from "lodash/truncate";
import EmptyValue from "./EmptyValue";
const _formatValue = (field, value, truncate, render, type) => {
  const stringified = isString(value) ? value : JSON.stringify(value);
  const Component = render;
  return trim(stringified) === "" ? /* @__PURE__ */ React.createElement(EmptyValue, null) : /* @__PURE__ */ React.createElement(Component, { field, value: truncate ? trunc(stringified) : stringified, type });
};
const DecoratorValue = ({ field, value, truncate, render, type }) => {
  if (value && value.href && value.type) {
    const formattedValue = _formatValue(field, value.href, truncate, render, type);
    return /* @__PURE__ */ React.createElement("a", { href: value.href, target: "_blank", rel: "noreferrer" }, formattedValue);
  }
  return _formatValue(field, value, truncate, render, type);
};
export default DecoratorValue;
